import { SET_DRIVERLIST } from '../actions';

const driverlist = (state = [], action) => {
  switch (action.type) {
	case SET_DRIVERLIST:
      return [...action.value];  
    default: return state;
  }
}

export default driverlist;
